import {
  Box,
  Link,
  Divider,
  MenuItem,
  MenuList,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";

export const purchaseSeatsLanguages = {
  progressBarText:
    "Add 3 games and get 5% off your tickets! Select all events in package that you wish to transact on behalf of the fan.",
  similarSeatModalBody: (seatTitle: string) => {
    return (
      <>
        Do you want to apply <b>{seatTitle.replace(/<br \/>/g, "")}</b> for all
        games in your pack?
      </>
    );
  },
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your Pistons account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description: "Select your games and seats.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Pistons 3 Game Push To The Playoffs Plan work?",
    description:
      "The Pistons 3 Game Push To The Playoffs Plan allows fans to select any seat for 3 games.  Simply log into your Pistons Account manager and select games.",
  },
  {
    title:
      "What additional benefits do I get through the Pistons 3 Game Push To The Playoffs Plan?",
    description:
      "At least 5% savings per game you will receive guaranteed access to any 2025 NBA Playoff ticket presales when seats become available",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "Yes, you must select all the games you'd like to attend throughout the season in one transaction.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description:
      "Tickets are delivered directly within your Detroit Pistons Account Manager.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function TopNavMenuItems() {
  const user = useAppStore(selectUser);

  return (
    <Box>
      {user ? <Divider /> : null}
      <MenuList>
        <MenuItem
          onClick={() => {
            window.open("https://forms.pistons.com/1450", "_blank");
          }}
        >
          <ListItemIcon>
            <OpenInNewRounded fontSize="small" />
          </ListItemIcon>
          <ListItemText>Speak To A Representative</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  );
}
